import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-base" }
const _hoisted_2 = { class: "fixed-top" }

import MsgBoxInfo from '@/common/MsgBoxInfo.vue';
  import MsgBoxWarning from '@/common/MsgBoxWarning.vue';
  import MsgBoxOkCancel from '@/common/MsgBoxOkCancel.vue';

  // ヘッダーモジュールのインポート
  import HeaderMenu from "./components/HeaderMenu.vue";

//#endregion


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  
/********************************************************************************
 * メインモジュール
 *
 * @since 2022/12/16
 * @author 松本裕介
 *
 *********************************************************************************/

//#region 共通モジュールのインポート

  // メッセージボックスのインポート
  
return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MsgBoxInfo),
    _createVNode(MsgBoxWarning),
    _createVNode(MsgBoxOkCancel),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createVNode(HeaderMenu)
      ]),
      _createElementVNode("main", null, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 64))
}
}

})